<template>
  <div class="gallery-card"
       @click="$root.$emit('openFullScreenGallery', element.id)">
    <b-img v-if="element.type === 0"
           :src="getGalleryImage(element.thumbnails)"
           :alt="element.description"
           fluid
           @error.native="$event.target.src = require('@/assets/images/placeholder-gallery.svg')" />
    <div v-else>
      <b-img :src="element.video_url | youtubeId"
             :alt="element.description"
             fluid
             @error.native="$event.target.src = require('@/assets/images/placeholder-gallery.svg')" />
      <div class="icon-play" />
    </div>
  </div>
</template>

<script>
export default {
  filters: {
    youtubeId: value => {
      return (
        'https://i3.ytimg.com/vi/' +
        value.split('https://www.youtube.com/embed/')[1] +
        '/sddefault.jpg'
      )
    }
  },
  props: {
    element: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    getGalleryImage(thumbnails) {
      if (thumbnails) return thumbnails.s_cd || thumbnails.m_dt
      return require('@/assets/images/placeholder-gallery.svg')
    }
  }
}
</script>

<style lang="scss">
@import './gallery-card.sass';
</style>
